module.exports = __webpack_public_path__ + "static/media/control_4.50e9fce9.svg";